//////////// CSS /////////////
import './styles.css';
import ic_back from './assets/icon/arrow_back.png';
import ic_more from './assets/icon/more_vert.png';
import ic_account from './assets/icon/ic_account.png';

//////////// REACT /////////////
import React from "react";
import { useHistory, useLocation } from "react-router-dom";

//////////// REDUX | STORE | PROVIDER /////////////
import { useDispatch, useSelector } from 'react-redux';
import { signout, selectAuthen } from '../../store/slice/authentication';
import { deleteCookie } from '../../store/cookie';

//////////// ASSETS /////////////
import logo_gcmpta from '../../assets/image/gcmptalogo_bgnone.png';

function Header(props) {

    const dispatch = useDispatch();
    const history = useHistory();
    const location = useLocation();

    const [splitPath, setSplitPath] = React.useState([]);
    const [stackRoute, setStackRoute] = React.useState({});
    const AuthenData = useSelector(selectAuthen);

    const ActiveHeaderRoute = React.useCallback(async () => {
        // console.log("AuthenData ---------> ", AuthenData);

        let currentPath = (location.pathname).replace("/d-rec-admin/", "");
        let pathSplitArr = currentPath.split("/");

        // console.log("location.state ---> " ,location.state);
        for (let index = 0; index < pathSplitArr.length; index++) {
            let str = pathSplitArr[index];

            if (str === "checksheet") {
                if (location.state.plantname) {
                    pathSplitArr[index] = location.state.plantname;
                    let _stack = stackRoute;
                    _stack.plantname = location.state.plantname;
                    setStackRoute(_stack);
                } else {
                    pathSplitArr[index] = stackRoute.plantname;
                }
            }

            if (str === "survey") {
                if (location.state.checksheetname) {
                    pathSplitArr[index] = location.state.checksheetname;
                    let _stack = stackRoute;
                    _stack.checksheetname = location.state.checksheetname;
                    setStackRoute(_stack);
                } else {
                    pathSplitArr[index] = stackRoute.checksheetname;
                }
            }

            if (str === "tag") {
                pathSplitArr[index] = "Survey";
                if (location.state.surveyno) {
                    pathSplitArr[index] += " - " + location.state.surveyno;
                    let _stack = stackRoute;
                    _stack.surveyno = location.state.surveyno;
                    setStackRoute(_stack);
                } else {
                    pathSplitArr[index] += " - " + stackRoute.surveyno;
                }
            }

            if (str === "view") {
                pathSplitArr[index] = "Work Order";
                if (location.state.workorderno) {
                    pathSplitArr[index] += " - " + location.state.workorderno;
                    let _stack = stackRoute;
                    _stack.surveyno = location.state.workorderno;
                    setStackRoute(_stack);
                } else {
                    pathSplitArr[index] += " - " + stackRoute.workorderno;
                }
            }

            if (str === "log") {
                pathSplitArr[index] = "";
                if (location.state.name) {
                    pathSplitArr[index] += location.state.name;
                    let _stack = stackRoute;
                    _stack.surveyno = location.state.name;
                    setStackRoute(_stack);
                } else {
                    pathSplitArr[index] += stackRoute.name;
                }
            }
        }

        setSplitPath(pathSplitArr);

    }, [location, stackRoute]);

    React.useEffect(() => {
        ActiveHeaderRoute();
    }, [ActiveHeaderRoute]);

    const [OpenMenu, setOpenMenu] = React.useState(false);
    const [anchorRefOpenMenu, setAnchorRefOpenMenu] = React.useState(false);

    function ToggleMenu(event) {
        event.preventDefault();
        if (OpenMenu) {
            setOpenMenu(false);
            document.removeEventListener('click', closeMenu);
        } else {
            setOpenMenu(true);
            document.addEventListener('click', closeMenu);
        }
    }

    function closeMenu(event) {
        /// Condition 'removeEventListener' all except ref element
        if (!anchorRefOpenMenu.contains(event.target)) {
            setOpenMenu(false);
            document.removeEventListener('click', closeMenu);
        }
    }

    async function onSignout() {
        await dispatch(signout());
        await deleteCookie("authen");
        await deleteCookie("token");
        history.replace("/d-rec-admin/login");
    }
    
    /// Clear state Ref element to null.
    React.useEffect(() => {
        return () => {
            setAnchorRefOpenMenu(null);
        };
    }, []);

    React.useEffect(() => {
        // console.log(splitPath);
        
        console.log("AuthenData ---> " ,AuthenData);
    }, [AuthenData]);

    return (
        <div className="main-header">
            {
                (splitPath.length > 1) ?
                    (<div className="back-button" onClick={() => { history.goBack(); }}>
                        <img src={ic_back} className="ic-back" alt="ic_back" />
                    </div>)
                    :
                    (<div className="back-button"></div>)

            }
            <img src={logo_gcmpta} className="logo" alt="logo" />
            <div className="content">
                {splitPath.map((location, index) => (
                    <div className="position-name" key={index} onClick={() => {
                        let findFormLinkApprove = splitPath.filter((path) => (path === "Form Link Approve") || (path === "Check sheet"));
                        if (findFormLinkApprove.length > 0) {
                            history.push('/d-rec-admin/main')
                        } else {
                            let count = (splitPath.length - index) - 1;
                            for (let i = 0; i < count; i++) {
                                history.goBack();
                            }
                            // console.log();
                        }
                    }}>
                        {index !== 0 ? <span style={{ margin: 10 }}>{`>`}</span> : <span></span>}
                        <span className={((index + 1) === splitPath.length ? "route active" : "route")}>{location.toUpperCase()}</span>
                    </div>
                ))}
            </div>
            <div>
                <img src={ic_account} className="ic-account" alt="ic_account" />
            </div>
            <div className='display-user'>
                <div className='name'>{AuthenData.user.name}</div>
                <div className='position'>{AuthenData.user.fqn}</div>
                <div className='position'>{AuthenData.user.department}</div>
            </div>
            <div className="back-button" ref={(element) => { setAnchorRefOpenMenu(element) }} onClick={ToggleMenu}>
                <img src={ic_more} className="ic-more" alt="ic_more" />
            </div>
            {
                OpenMenu ? (<div className={"toggle-menu"}> <div className='list' onClick={onSignout}>logout</div> </div>) : (null)
            }
        </div>
    );
}

export default Header;